import { Icon2d, IconProps2d } from "Components/Icons/common";
import React from "react";
import { forwardRef } from "react";

const Icons: Icon2d = forwardRef<SVGSVGElement, IconProps2d>(({ color = "currentColor", width = 63, height = 38, onClick = () => { /*empty*/ }, ...rest }, ref) => <svg onClick={onClick} ref={ref} width={width} height={height} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 63 38" fill="none" {...rest}>
   <rect width="32" height="32" y="3" fill="#00293A" rx="8" />
   <path stroke="#fff" strokeWidth="2.407" d="M22.18 9.762a3.006 3.006 0 0 1 2.141.895 3.056 3.056 0 0 1 .887 2.16 3.08 3.08 0 0 1-.887 2.161 3.027 3.027 0 0 1-2.142.895M9.905 22.038a3.008 3.008 0 0 0-2.142.895 3.057 3.057 0 0 0-.887 2.16 3.079 3.079 0 0 0 .887 2.16 3.03 3.03 0 0 0 2.142.895M19.516 11.226l-6.947 15.356M22.18 15.873H0M32 22.037H9.905" />
   <g filter="url(#a)" opacity=".2">
      <ellipse cx="17.247" cy="15.994" fill="url(#b)" rx="2.879" ry="1.998" />
   </g>
   <path stroke="#fff" strokeWidth="2.407" d="M22.205 9.762c-.522 0-1.802 0-2.69 1.463l-3.473 7.677" />
   <g filter="url(#c)" opacity=".2">
      <ellipse cx="14.735" cy="22.045" fill="url(#d)" rx="2.982" ry="1.998" />
   </g>
   <path stroke="#fff" strokeWidth="2.407" d="M9.853 28.148c1.045 0 2.115-.444 2.716-1.567l3.473-7.677" />
   <rect width="35" height="35" x="26.5" y="1.5" fill="#fff" rx="17.5" />
   <rect width="35" height="35" x="26.5" y="1.5" fill="url(#e)" fillOpacity=".2" rx="17.5" />
   <rect width="35" height="35" x="26.5" y="1.5" stroke="#fff" strokeWidth="3" rx="17.5" />
   <path fill="#00609C" fillRule="evenodd" d="M48.167 13.167h-8.334v11.666h8.334V13.167ZM39.833 11.5c-.92 0-1.666.746-1.666 1.667V26.5h11.666V13.167c0-.92-.746-1.667-1.666-1.667h-8.334Zm1.667 6.667h1.667v1.666H41.5v-1.666Zm1.667-3.334H41.5V16.5h1.667v-1.667Zm1.666 3.334H46.5v1.666h-1.667v-1.666Zm1.667-3.334h-1.667V16.5H46.5v-1.667Zm-5 6.667h1.667v1.667H41.5V21.5Zm5 0h-1.667v1.667H46.5V21.5Z" clipRule="evenodd" />
   <defs>
      <radialGradient id="b" cx="0" cy="0" r="1" gradientTransform="matrix(0 1.99779 -2.87917 0 17.247 15.994)" gradientUnits="userSpaceOnUse">
         <stop stopColor="#00293A" />
         <stop offset="1" stopColor="#00293A" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="d" cx="0" cy="0" r="1" gradientTransform="matrix(0 1.99779 -2.982 0 14.735 22.045)" gradientUnits="userSpaceOnUse">
         <stop stopColor="#00293A" />
         <stop offset="1" stopColor="#00293A" stopOpacity="0" />
      </radialGradient>
      <filter id="a" width="7.521" height="5.759" x="13.486" y="13.115" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
         <feFlood floodOpacity="0" result="BackgroundImageFix" />
         <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
         <feGaussianBlur result="effect1_foregroundBlur_11874_137111" stdDeviation=".441" />
      </filter>
      <filter id="c" width="7.727" height="5.759" x="10.872" y="19.166" colorInterpolationFilters="sRGB" filterUnits="userSpaceOnUse">
         <feFlood floodOpacity="0" result="BackgroundImageFix" />
         <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
         <feGaussianBlur result="effect1_foregroundBlur_11874_137111" stdDeviation=".441" />
      </filter>
      <linearGradient id="e" x1="28" x2="60" y1="3" y2="35" gradientUnits="userSpaceOnUse">
         <stop stopColor="#11DEB9" />
         <stop offset="1" stopColor="#2797FF" />
      </linearGradient>
   </defs>
</svg>);
export default Icons;